/* nc-faq — accordion controller. Multiple items may be open. Native buttons (keyboard for free).
   Self-contained, per-instance, no globals. */
(function () {
  'use strict';

  function init(root) {
    if (root.__ncFaqReady) return;
    root.__ncFaqReady = true;

    root.querySelectorAll('.qbtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qa = btn.closest('.qa');
        if (!qa) return;
        var open = qa.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nc-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-faq]') : null;
    if (el) init(el);
  });
})();
